<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 25 33.013">
  <g id="rapport" transform="translate(-1666.608 -20.782)">
    <path id="Tracé_39" data-name="Tracé 39"
      d="M1689.44,44.285h-11.552a.524.524,0,0,0,0,1.048h11.552a.524.524,0,1,0,0-1.048Z"
      transform="translate(-2.34 -2.072)" fill="#3c3c3b" />
    <path id="Tracé_40" data-name="Tracé 40"
      d="M1672.311,36.716a1.719,1.719,0,1,0,1.719,1.719A1.742,1.742,0,0,0,1672.311,36.716Zm0,2.39a.671.671,0,1,1,.671-.671A.656.656,0,0,1,1672.311,39.106Z"
      transform="translate(0 -1.507)" fill="#3c3c3b" />
    <path id="Tracé_41" data-name="Tracé 41"
      d="M1689.44,50.658h-11.552a.525.525,0,0,0,0,1.049h11.552a.525.525,0,0,0,0-1.049Z"
      transform="translate(-2.34 -3.09)" fill="#3c3c3b" />
    <path id="Tracé_42" data-name="Tracé 42"
      d="M1689.44,37.911h-11.552a.524.524,0,0,0,0,1.048h11.552a.524.524,0,1,0,0-1.048Z"
      transform="translate(-2.34 -1.51)" fill="#3c3c3b" />
    <path id="Tracé_43" data-name="Tracé 43"
      d="M1672.311,30.342a1.719,1.719,0,1,0,1.719,1.72A1.743,1.743,0,0,0,1672.311,30.342Zm0,2.391a.671.671,0,1,1,.671-.671A.656.656,0,0,1,1672.311,32.733Z"
      transform="translate(0 -0.904)" fill="#3c3c3b" />
    <path id="Tracé_44" data-name="Tracé 44"
      d="M1672.311,49.463a1.719,1.719,0,1,0,1.719,1.72A1.743,1.743,0,0,0,1672.311,49.463Zm0,2.391a.671.671,0,1,1,.671-.671A.656.656,0,0,1,1672.311,51.854Z"
      transform="translate(0 -3.09)" fill="#3c3c3b" />
    <path id="Tracé_45" data-name="Tracé 45"
      d="M1672.311,43.089a1.719,1.719,0,1,0,1.719,1.72A1.743,1.743,0,0,0,1672.311,43.089Zm0,2.391a.671.671,0,1,1,.671-.671A.656.656,0,0,1,1672.311,45.48Z"
      transform="translate(0 -2.11)" fill="#3c3c3b" />
    <path id="Tracé_46" data-name="Tracé 46"
      d="M1677.888,32.586h11.552a.524.524,0,1,0,0-1.048h-11.552a.524.524,0,0,0,0,1.048Z"
      transform="translate(-2.34 -0.948)" fill="#3c3c3b" />
    <path id="Tracé_47" data-name="Tracé 47"
      d="M1691.128,24.425h-5.348v-.978a.512.512,0,0,0-.479-.479h-3.065l-.066-.148a3.32,3.32,0,0,0-6.124,0l-.066.148h-3.064a.512.512,0,0,0-.479.479v.978h-5.349a.514.514,0,0,0-.479.479V53.316a.512.512,0,0,0,.479.479h24.041a.507.507,0,0,0,.48-.48V24.9A.507.507,0,0,0,1691.128,24.425Zm-17.733-.5h2.891a.5.5,0,0,0,.463-.368,2.441,2.441,0,0,1,4.719,0,.506.506,0,0,0,.465.371h2.889V26.61h-11.427Zm17.254,28.91h-23.082V25.383h4.869V27.09a.512.512,0,0,0,.479.479H1685.3a.512.512,0,0,0,.479-.479V25.383h4.869Z"
      fill="#3c3c3b" />
  </g>
</svg>